import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigLoaderService } from './config-loader.service';

interface CompanyCodeMapping {
  公司代碼: string | number;
  網路預約代碼: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyCodeMappingService {
  private mappingData: CompanyCodeMapping[] = [];
  private isLoaded = false;

  constructor(
    private http: HttpClient,
    private configLoader: ConfigLoaderService
  ) {
    this.loadMappingData();
  }

  private loadMappingData(): void {
    // 根據環境決定載入哪個檔案
    const env = (window as any)?.env?.environment || 'dev';
    const fileName = env === 'prod' 
      ? 'company-mapping-prod.json' 
      : 'company-mapping-uat.json';
    
    const filePath = `assets/data/${fileName}`;
    
    this.http.get<CompanyCodeMapping[]>(filePath)
      .pipe(
        catchError(error => {
          console.error(`載入公司代碼對照表失敗 (${fileName}):`, error);
          return of([]);
        })
      )
      .subscribe(data => {
        this.mappingData = data;
        this.isLoaded = true;
        console.log(`已載入公司代碼對照表: ${fileName}, 共 ${data.length} 筆資料`);
      });
  }

  /**
   * 將網路預約代碼轉換為公司代碼
   * @param webCode 網路預約代碼
   * @returns 公司代碼,如果找不到則返回原始輸入
   */
  convertWebCodeToCompanyCode(webCode: string): string {
    if (!webCode) return '';
    
    const trimmedCode = webCode.trim().toUpperCase();
    const mapping = this.mappingData.find(
      item => item.網路預約代碼.toUpperCase() === trimmedCode
    );
    
    return mapping ? String(mapping.公司代碼) : webCode;
  }

  /**
   * 檢查是否為有效的網路預約代碼
   */
  isValidWebCode(webCode: string): boolean {
    if (!webCode) return false;
    
    const trimmedCode = webCode.trim().toUpperCase();
    return this.mappingData.some(
      item => item.網路預約代碼.toUpperCase() === trimmedCode
    );
  }
}
